import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, Input, Table, Button, Alert, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faTrash } from '@fortawesome/free-solid-svg-icons'
import { CopyToClipboard } from 'react-copy-to-clipboard';

export class MyLinks extends Component {
  state = {
    loading: false,
    error: '',
    links: [],
    query: '',
    deleting: null,
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.load();
    }
  }

  load() {
    this.setState({ loading: true, error: '' });
    fetch('/api/links')
      .then(r => r.json())
      .then(data => this.setState(data.error ? { error: data.error } : { links: data.links || [] }))
      .catch(() => this.setState({ error: 'unknown error' }))
      .finally(() => this.setState({ loading: false }));
  }

  remove(key) {
    if (!window.confirm('删除 ' + key + ' ?')) return;
    this.setState({ deleting: key, error: '' });
    fetch('/api/links/' + encodeURIComponent(key), { method: 'DELETE' })
      .then(r => r.json())
      .then(data => {
        if (data.error) {
          this.setState({ error: data.error });
        } else {
          this.setState(s => ({ links: s.links.filter(l => l.key !== key) }));
        }
      })
      .catch(() => this.setState({ error: 'unknown error' }))
      .finally(() => this.setState({ deleting: null }));
  }

  render() {
    const prefix = window.location.origin + '/';
    const q = this.state.query.trim().toLowerCase();
    const links = q
      ? this.state.links.filter(l => l.key.toLowerCase().includes(q) || (l.url || '').toLowerCase().includes(q))
      : this.state.links;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="lg" scrollable>
        <ModalHeader toggle={this.props.toggle}>我的链接</ModalHeader>
        <ModalBody>
          {this.state.error ? <Alert color="danger">{this.state.error}</Alert> : ''}
          <Input
            placeholder="搜索短链或网址"
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
            style={{ marginBottom: 12 }}
          />
          {this.state.loading
            ? <div style={{ textAlign: 'center' }}><Spinner size="sm" /></div>
            : links.length === 0
              ? <div className="text-muted" style={{ textAlign: 'center' }}>{q ? '没有匹配的链接' : '还没有链接'}</div>
              : <Table size="sm" hover responsive style={{ tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={{ width: '9em' }}>短链</th>
                    <th>网址</th>
                    <th style={{ width: '7em' }}>时间</th>
                    <th style={{ width: '6em' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {links.map(l => (
                    <tr key={l.key}>
                      <td><a href={prefix + l.key} target="_blank" rel="noopener noreferrer">{l.key}</a></td>
                      <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={l.url}>{l.url}</td>
                      <td className="text-muted">{l.created ? new Date(l.created).toLocaleDateString() : ''}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        <CopyToClipboard text={prefix + l.key}>
                          <Button size="sm" color="link" title="复制"><FontAwesomeIcon icon={faCopy} /></Button>
                        </CopyToClipboard>
                        <Button size="sm" color="link" className="text-danger" title="删除"
                          disabled={this.state.deleting === l.key}
                          onClick={() => this.remove(l.key)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>}
        </ModalBody>
      </Modal>
    );
  }
}
